module.exports = __webpack_public_path__ + "static/media/ipad-pro-set-genie-app-store-reduced.14ed9193.png";